import { api } from './client'

/**
 * Opening authenticated files.
 *
 * A browser navigating to a URL sends no Authorization header, so a plain link to
 * a document 401s against a real API. These fetch the bytes with the caller's
 * token and hand the result to the browser as a local object URL instead.
 *
 * The object URL is revoked on a timer rather than immediately: revoking before
 * the new tab or the download has read it produces an empty file, and there is no
 * event that reliably says "done". A minute is far longer than either needs.
 */
const RELEASE_AFTER_MS = 60_000

function release(url: string) {
  setTimeout(() => URL.revokeObjectURL(url), RELEASE_AFTER_MS)
}

/** Opens a document in a new tab, in the browser's own PDF or image viewer. */
export async function openDocument(vehicleId: number, documentId: number) {
  const url = await api.fetchDocumentBlobUrl(vehicleId, documentId)
  window.open(url, '_blank', 'noopener')
  release(url)
}

/** Saves a document under its own name. */
export async function saveDocument(vehicleId: number, documentId: number, fileName: string) {
  const url = await api.fetchDocumentBlobUrl(vehicleId, documentId)
  triggerDownload(url, fileName)
  release(url)
}

/** Saves the report workbook. */
export async function saveWorkbook(vehicleIds: number[], fileName: string) {
  const url = await api.fetchReportWorkbook(vehicleIds)
  triggerDownload(url, fileName)
  release(url)
}

function triggerDownload(url: string, fileName: string) {
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = fileName
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
}
